import * as React from 'react';
export const IcKabaddi = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16.5 7a1.5 1.5 0 001.39-.93c.121-.27.16-.569.11-.86A1.49 1.49 0 0016.79 4a1.49 1.49 0 00-.86.08 1.55 1.55 0 00-.68.56A1.5 1.5 0 0016.5 7zm-8 0a1.5 1.5 0 001.39-.93c.121-.27.16-.569.11-.86A1.49 1.49 0 008.79 4a1.49 1.49 0 00-.86.08 1.55 1.55 0 00-.68.56A1.5 1.5 0 008.5 7zM22 18.71l-3-10a1 1 0 00-.38-.53A1 1 0 0018 8h-5a1 1 0 00-.71.29A1.05 1.05 0 0012 9a1 1 0 00.29.71A1.001 1.001 0 0013 10h4.26l.74 2.47-2.55 1.7a1 1 0 00-.45 1.07l1 4a1 1 0 00.46.64 1.06 1.06 0 001.147-.044c.11-.08.203-.18.273-.296a1.06 1.06 0 00.12-.78l-.83-3.32 1.46-1L20 19.29c.038.132.103.254.19.36.081.11.188.2.31.26.12.068.253.113.39.13.132.025.268.025.4 0a1 1 0 00.36-.19.86.86 0 00.26-.31.89.89 0 00.12-.38.94.94 0 00-.03-.45zm-9.51-7.57l-5-3a1.07 1.07 0 00-.96-.05 1 1 0 00-.38.3 1.06 1.06 0 00-.15.45l-1 5.75-2.81 3.81A1 1 0 003 20a1 1 0 00.8-.4l3-4a1 1 0 00.2-.44l.11-.65.9.9V19a1 1 0 002 0v-4a1 1 0 00-.07-.38 1 1 0 00-.22-.33l-2-2c-.07-.052-.143-.1-.22-.14l.26-1.54 3.74 2.25a1 1 0 001.28-.41 1 1 0 00.11-.71 1 1 0 00-.4-.6z'
      fill='currentColor'
    />
  </svg>
);
